export default {
  fr: {
    title:
      "Souhaitez-vous qu’un·e intervenant·e de la SQS vous contacte pour vous aider ?",
    lastName: "Nom",
    firstName: "Prénom",
    situation: "Votre situation",
    situationSelf: {
      before: "J’ai un doute sur ",
      emphasis: "ma",
      after: " santé mentale",
    },
    situationLovedOne: {
      before: "J’ai un doute sur la santé mentale d’un ",
      emphasis: "proche",
      after: "",
    },
    contactMethod: "Préférez-vous être contacté·e par",
    email: "Courriel",
    phone: "Téléphone",
    voicemailConsent: "Pouvons-nous vous laisser un message vocal ?",
    yes: "Oui",
    no: "Non",
    details: "Voulez-vous nous en dire plus sur la situation ?",
    consent:
      "J’accepte que les renseignements fournis soient transmis à la SQS afin qu’elle communique avec moi au sujet de ma demande.",
    submit: "Envoyer la demande",
    submitting: "Envoi en cours…",
    success: "Votre demande a été envoyée avec succès.",
    failure:
      "Une erreur est survenue pendant l’envoi de votre demande. Veuillez réessayer.",
    invalid: "Veuillez corriger les champs indiqués avant d’envoyer.",
    required: "Ce champ est obligatoire.",
    invalidEmail: "Veuillez saisir une adresse courriel valide.",
  },
  en: {
    title: "Would you like an SQS worker to contact you for help?",
    lastName: "Last name",
    firstName: "First name",
    situation: "Your situation",
    situationSelf: {
      before: "I have concerns about ",
      emphasis: "my",
      after: " own mental health",
    },
    situationLovedOne: {
      before: "I have concerns about a ",
      emphasis: "loved one",
      after: "’s mental health",
    },
    contactMethod: "How would you prefer to be contacted?",
    email: "Email",
    phone: "Phone",
    voicemailConsent: "May we leave you a voicemail?",
    yes: "Yes",
    no: "No",
    details: "Would you like to tell us more about the situation?",
    consent:
      "I agree that the information provided may be sent to SQS so that SQS may contact me regarding my request.",
    submit: "Send request",
    submitting: "Sending…",
    success: "Your request has been sent successfully.",
    failure: "An error occurred while sending your request. Please try again.",
    invalid: "Please correct the indicated fields before submitting.",
    required: "This field is required.",
    invalidEmail: "Please enter a valid email address.",
  },
}
